'use client';

import { c as _c } from "react/compiler-runtime";
import { useGetPlatformConfig, useMarketConfig, useMarketConfigCatalog } from '@morfi/backend-sdk-v2/client';
export interface CreationFeeParams {
  feeBpsBacking: number | undefined;
  feeBpsBuy: number | undefined;
  feeBpsSellNormal: number | undefined;
  feeSplitBackersBps: number | undefined;
  creationThresholdD6: string | undefined;
  isLoading: boolean;
  isError: boolean;
  configStatus: 'loading' | 'ready' | 'unavailable';
}

/** Omit the address only for creation; null is an unavailable existing proposal. */
export function useCreationFeeParams(t0, address) {
  const $ = _c(12);
  const enabled = t0 === undefined ? true : t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      kind: "market",
      fields: ["marketConfig"]
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = enabled && address === undefined;
  let t3;
  if ($[1] !== t2) {
    t3 = {
      enabled: t2
    };
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const current = useGetPlatformConfig(t1, t3);
  const catalog = useMarketConfigCatalog();
  const data = useMarketConfig(address === undefined ? current.data?.marketConfig : address);
  const isLoading = enabled && (catalog.status === "loading" || address === undefined && current.isPending);
  const configStatus = data !== undefined ? "ready" : isLoading ? "loading" : "unavailable";
  const t4 = data?.feeBpsBacking;
  const t5 = data?.feeBpsBuy;
  const t6 = data?.feeBpsSellNormal;
  const t7 = data?.feeSplitBackersBps;
  const t8 = data?.creationThresholdD6;
  const t9 = configStatus === "unavailable";
  let t10;
  if ($[3] !== configStatus || $[4] !== isLoading || $[5] !== t4 || $[6] !== t5 || $[7] !== t6 || $[8] !== t7 || $[9] !== t8 || $[10] !== t9) {
    t10 = {
      feeBpsBacking: t4,
      feeBpsBuy: t5,
      feeBpsSellNormal: t6,
      feeSplitBackersBps: t7,
      creationThresholdD6: t8,
      isLoading,
      isError: t9,
      configStatus
    };
    $[3] = configStatus;
    $[4] = isLoading;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
    $[9] = t8;
    $[10] = t9;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  return t10;
}